<p class="tooltiptext tooltip-top tooltip-error" style="opacity: 1; visibility:visible">
  <fa-icon [icon]="faExclamationTriangle"></fa-icon>
  <br>
  <span>{{ error | translate }}</span>
</p>
